





























































































import { Component, Prop, Vue } from "vue-property-decorator";
import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconCamera from "@/common/components/icons/IconCamera.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import InputTextarea from "@/common/components/atoms/InputTextarea.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import FormLabel from "@/common/components/organisms/FormLabel.vue";
import commons from "@/common/store/modules/commons";

import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { max } from "vee-validate/dist/rules";
import {
  patchCustomUserDetail
} from "@/general/store/api";
import globals from "@/general/store/modules/globals";

import axios from "axios";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";
import AuthApi from "@/general/api/authApi";

extend("max", {
  ...max,
  message: "{_field_}は{length}文字以内を入力してください。"
});

@Component({
  components: {
    TheTemplateM,
    IconBase,
    IconUserImage,
    IconCamera,
    InputText,
    InputTextarea,
    ButtonMain,
    FormLabel,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver
  }
})
export default class ProfileUpdate extends Vue {
  formData: any = [];

  @Prop({ type: Number, default: 1 }) id!: number;

  icon: any = null;
  iconPreview = "";
  bio = "";
  breadcrumb = [
    {
      text: "",
      url: "/home/",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page/",
      pageType: "lower"
    },
    {
      text: "プロフィール編集",
      url: "/",
      pageType: "lower"
    }
  ];

  submit(ObserverProps: any) {
    ObserverProps.passes(() => {
      this.$refs.form as Vue & { submit: () => boolean };
    });
  }

  selectedIconFile(e: any) {
    e.preventDefault();
    this.icon = e.target.files[0];

    this.iconPreview = URL.createObjectURL(e.target.files[0]);

    // this.uploadIconFile();
  }
  // uploadIconFile() {
  // const self = this;

  //   const uploadFormData = new FormData();
  //   uploadFormData.append("icon", this.icon);
  //   const config = {
  //     headers: {
  //       "content-type": "multipart/form-data"
  //     }
  //   };

  //   axios
  //     .post("/api/general/uploadIconFile/", uploadFormData, config)
  //     .then(response => {
  //       this.iconPreview = response.data.icon_preview;
  //     })
  //     .catch(error => {
  //       // TODO: エラー対応
  //     });
  // }
  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );

    this.id = userDetails.id;
    //this.iconPreview = userDetails.avatar;
    this.bio = userDetails.bio;

    //#59042対応によりセッション情報からavatarを取得するように修正
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.iconPreview = ic_session.avatar;
    })
    .catch(() => {
      this.iconPreview = "";
    });

    await commons.getBreadcrumb(this.breadcrumb);
  }

  async updateProfile() {
    const response = await patchCustomUserDetail(
      this.id,
      this.bio ? this.bio : undefined,
      this.icon ? this.icon : undefined
    );

    if (response) {
      window.location.href = "/my-page/profile-update-complete.html";
    }
  }
}
